import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { PermissionDto, UserProfileApi } from '../../../api-client';

type UseGetEffectivePermissions = (
  userProfileApi: UserProfileApi,
  options: UseQueryOptions,
) => UseQueryResult<PermissionDto[]>;

const QUERY_KEY = 'effectivePermissions';

export const useGetOwnPermissions: UseGetEffectivePermissions = (
  userProfileApi: UserProfileApi,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useQuery(
    [QUERY_KEY],
    async () => userProfileApi.getOwnPermissions(tenantId).then((res) => res.data),
    { keepPreviousData: false },
  );
};
